import React, {Component} from 'react';
import PropTypes from 'prop-types';

class TableColumnOrdered extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderActive: this.props.orderActive,
            direction: this.props.orderDirection
        };
        this.onChangeDirection = this.onChangeDirection.bind(this)
        this.onChangeOrder = this.onChangeOrder.bind(this)
        this.sendOnChangeOrder = this.sendOnChangeOrder.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            orderActive: nextProps.orderActive,
            direction: nextProps.orderDirection
        })
    }

    onChangeDirection(){
        let newState = {
            direction: this.state.direction === 'A' ? 'D' : 'A'
        }
        this.setState(newState)
        this.sendOnChangeOrder(newState.direction);
    }

    onChangeOrder(){
        let newState = {
            orderActive: true,
            direction: 'A'
        }
        this.setState(newState)
        this.sendOnChangeOrder(newState.direction);
    }

    sendOnChangeOrder(direction){
        if (this.props.onChangeOrder !== undefined)
        {
            let fields = this.props.orderFields.split(",");
            let data=[];
            for (let i=0; i<fields.length; i++){
                data.push({
                   field: fields[i], direction: direction
                });
            }
            this.props.onChangeOrder(this.props.name, direction, data)
        }
    }

    render() {
        if (this.props.enabled){
            let classcnt = this.state.direction === 'A' ? "sorted ascending" : this.state.direction === 'D' ? "sorted descending" : ""
            classcnt = this.props.className + " " + classcnt
            return (this.state.orderActive ?
                    <th className={classcnt} onClick={this.onChangeDirection}>
                        {this.props.children}
                    </th>
                    :
                    <th onClick={this.onChangeOrder}>{this.props.children}</th>
            )

        }
        else {
            return <th>{this.props.children}</th>
        }
    }
}

TableColumnOrdered.PropTypes = {
    className: PropTypes.string,
    name: PropTypes.string,
    orderActive: PropTypes.bool,
    enabled: PropTypes.bool,
    orderFields: PropTypes.string,
    orderDirection: PropTypes.oneOf(['A', 'D']),
    onChangeOrder: PropTypes.func
}

TableColumnOrdered.defaultProps = {
    enabled: true,
};
export default TableColumnOrdered;




/** WEBPACK FOOTER **
 ** ./src/components/TableColumnOrdered.js
 **/